{
	"countries": {
		"AR": { "handle": "change_ar" },
		"AT": { "handle": "changeorg_deutschland" },
		"BO": { "handle": "changeorg_latino" },
		"BR": { "handle": "changeorg_br" },
		"CA": { "handle": "change.org_ca" },
		"BY": { "handle": "changeorgbelarus" },
		"CL": { "handle": "changeorg_latino" },
		"CO": { "handle": "changeorg_co" },
		"CR": { "handle": "changeorg_latino" },
		"CU": { "handle": "changeorg_latino" },
		"DE": { "handle": "change.org_de" },
		"DO": { "handle": "changeorg_latino" },
		"EC": { "handle": "changeorg_latino" },
		"ES": { "handle": "change_es" },
		"FR": { "handle": "change_france" },
		"GB": { "handle": "change.org_uk" },
		"GT": { "handle": "changeorg_latino" },
		"HN": { "handle": "changeorg_latino" },
		"ID": { "handle": "changeorg_id" },
		"IN": {	"handle": "change.orgindia",
			"localesOverrides": {
				"hi-IN": "change.org_hindi"
			}
		},
		"IT": { "handle": "change.org_italia" },
		"JP": { "handle": "change.org.japan" },
		"KE": { "handle": "change.orgke" },
		"MX": { "handle": "change_mx" },
		"NI": { "handle": "changeorg_latino" },
		"PA": { "handle": "changeorg_latino" },
		"PE": { "handle": "changeorg_latino" },
		"PL": { "handle": "change_polska" },
		"PR": { "handle": "changeorg_latino" },
		"PY": { "handle": "changeorg_latino" },
		"RU": { "handle": "changeorgrus" },
		"SV": { "handle": "changeorg_latino" },
		"TR": { "handle": "changetr" },
		"UK": { "handle": "change.org_uk" },
		"US": { "handle": "changedotorg" },
		"UY": { "handle": "changeorg_latino" },
		"VE": { "handle": "changeorg_latino" }
	},
	"defaultHandle": "changedotorg"
}
